import React, { Component } from "react"
import { Row, Col, FormGroup, Button, FormControl, InputGroup, ControlLabel } from "react-bootstrap"
import { CSVLink } from 'react-csv'
import ContentWrapper from "../../../components/layout/ContentWrapper"
import { darkgray } from '../../../utils/constants'
import { OilRatioHeaders, SeasonSettingsHeaders, PointsByEventHeaders, RankingExceptionsHeaders, LowGameCountHeaders, SeasonsBowledHeaders, EventByEventHeaders, StandingsByEventHeaders } from './constants'
import {
  getSeasonDates, getOilRatiosReport, getSeasonSettingsReport, getPointsByEventReport, getRankingExceptionsReport,
  getLowGameCountReport, getSeasonsBowledReport, getEventByEventReport, getStandingsByEventReport } from './api'

const searchTypes = {
  OilRatios: 'oilratios',
  SeasonSettings: 'seasonsettings',
  PointsByEvent: 'pointsbyevent',
  RankingExceptions: 'rankingexceptions',
  LowGameCount: 'lowgamecount',
  SeasonsBowled: 'seasonsbowled',
  EventByEvent: 'eventbyevent',
  StandingsByEvent: 'standingsbyevent'
}

const reportStyle = {
  border: `1px solid ${darkgray}`,
  borderRadius: '3px',
  color: 'green'
}

class Reports extends Component {
  constructor(props) {
    super(props)

    this.state = {
      oilRatiosList: [],
      seasonSettingsList: [],
      pointsByEventList: [],
      lowGameCountList: [],
      rankingExceptionsList: [],
      seasonsBowledList: [],
      eventByEventList: [],
      standingsByEventList: [],
      reportType: searchTypes.OilRatios,
      season: -1,
      startDate: '',
      endDate: '',
      makingReportRequest: false,
      seasonDates: []
    }

    this.handleGenerateReport = this.handleGenerateReport.bind(this)
    this.handleSearchTypeChange = this.handleSearchTypeChange.bind(this)
    this.handleSeasonChange = this.handleSeasonChange.bind(this)
    this.getOilRatios = this.getOilRatios.bind(this)
    this.getSeasonSettings = this.getSeasonSettings.bind(this)
    this.getSeasonsBowled = this.getSeasonsBowled.bind(this)
    this.disableSearchButton = this.disableSearchButton.bind(this)
    this.seasonOptions = this.seasonOptions.bind(this)
    this.getSeasonDates = this.getSeasonDates.bind(this)
    this.getPointsByEvent = this.getPointsByEvent.bind(this)
    this.getLowGameCount = this.getLowGameCount.bind(this)
    this.getRankingExceptions = this.getRankingExceptions.bind(this)
    this.handleStartDateChange = this.handleStartDateChange.bind(this)
    this.handleEndDateChange = this.handleEndDateChange.bind(this)
    this.getEventByEvent = this.getEventByEvent.bind(this)
    this.getStandingsByEvent = this.getStandingsByEvent.bind(this)
  }

  componentDidMount() {
    this.getSeasonDates()
  }

  handleSearchTypeChange(event) {
    const searchType = event.target.value
    this.setState({ reportType: searchType })
    if (searchType == searchTypes.OilRatios || searchType == searchTypes.RankingExceptions || searchType == searchTypes.LowGameCount || searchType == searchTypes.EventByEvent || searchType == searchTypes.StandingsByEvent) {
      this.setState({ season: -1 })
    } else if (searchType == searchTypes.SeasonSettings || searchType == searchTypes.PointsByEvent || searchType == searchTypes.SeasonsBowled) {
      this.setState({ startDate: '', endDate: '' })
    }
  }

  handleSeasonChange(event) {
    const seasonYear = event.target.value
    this.setState({ season: seasonYear })
  }

  handleStartDateChange(event) {
    const date = event.target.value
    this.setState({ startDate: date })
  }

  handleEndDateChange(event) {
    const date = event.target.value
    this.setState({ endDate: date })
  }

  handleGenerateReport() {
    const { reportType, season, startDate, endDate } = this.state
    this.setState({ makingReportRequest: true })
    switch (reportType) {
      case searchTypes.OilRatios: this.getOilRatios(startDate, endDate); break;
      case searchTypes.SeasonSettings: this.getSeasonSettings(season); break;
      case searchTypes.PointsByEvent: this.getPointsByEvent(season); break;
      case searchTypes.RankingExceptions: this.getRankingExceptions(startDate, endDate); break;
      case searchTypes.LowGameCount: this.getLowGameCount(startDate, endDate); break;
      case searchTypes.SeasonsBowled: this.getSeasonsBowled(season); break;
      case searchTypes.EventByEvent: this.getEventByEvent(season); break;
      case searchTypes.StandingsByEvent: this.getStandingsByEvent(season); break;
      default: break;
    }
  }

  getOilRatios(startDate, endDate) {
    const _this = this
    getOilRatiosReport(startDate, endDate).then(function (response) {
      _this.setState({ makingReportRequest: false, oilRatiosList: response.data })
      document.getElementById("csvLink").click()
    })
  }

  getSeasonSettings(season) {
    const _this = this
    getSeasonSettingsReport(season).then(function (response) {
      _this.setState({ makingReportRequest: false, seasonSettingsList: response.data })
      document.getElementById("csvLink").click()
    })
  }

  getSeasonsBowled(season) {
    const _this = this
    getSeasonsBowledReport(season).then(function (response) {
      _this.setState({ makingReportRequest: false, seasonsBowledList: response.data })
      document.getElementById("csvLink").click()
    })
  }

  getPointsByEvent(season) {
    const _this = this
    getPointsByEventReport(season).then(function (response) {
      _this.setState({ makingReportRequest: false, pointsByEventList: response.data })
      document.getElementById("csvLink").click()
    })
  }

  getRankingExceptions(startDate, endDate) {
    const _this = this
    getRankingExceptionsReport(startDate, endDate).then(function (response) {
      _this.setState({ makingReportRequest: false, rankingExceptionsList: response.data })
      document.getElementById("csvLink").click()
    })
  }

  getLowGameCount(startDate, endDate) {
    const _this = this
    getLowGameCountReport(startDate, endDate).then(function (response) {
      _this.setState({ makingReportRequest: false, lowGameCountList: response.data })
      document.getElementById("csvLink").click()
    })
  }

  getEventByEvent(season) {
    const _this = this
    getEventByEventReport(season).then(function (response) {
      _this.setState({ makingReportRequest: false, eventByEventList: response.data })
      document.getElementById("csvLink").click()
    })
  }

  getStandingsByEvent(season) {
    const _this = this
    getStandingsByEventReport(season).then(function (response) {
      _this.setState({ makingReportRequest: false, standingsByEventList: response.data })
      document.getElementById("csvLink").click()
    })
  }

  getSeasonDates() {
    const _this = this
    getSeasonDates().then(function (response) {
      _this.setState({ seasonDates: response.data })
    })
  }

  disableSearchButton() {
    const { season, reportType, startDate, endDate } = this.state
    if (reportType === searchTypes.SeasonSettings || reportType === searchTypes.PointsByEvent || reportType === searchTypes.SeasonsBowled || reportType === searchTypes.EventByEvent || reportType === searchTypes.StandingsByEvent) {
      const noSeasonSpecified = (season == -1)
      return noSeasonSpecified
    } else if (reportType === searchTypes.OilRatios || reportType === searchTypes.RankingExceptions) {
      const noDateSpecified = (startDate == '' || endDate == '')
      return noDateSpecified
    }
  }

  seasonOptions() {
    const { seasonDates } = this.state
    const seasondatesarray = Object.values(seasonDates)
    const option = seasondatesarray.map((season) => {
      return (<option key={season.id} value={season.id}>{season.description}</option>)
    })
    return option
  }

  setSelectValues = () => {
    return (
      <FormControl componentClass="select"
        placeholder="All" onChange={this.handleSeasonChange}
        style={{ minWidth: '150px', borderRadious: '0', maxWidth: '60px' }}>
        <option value="-1">Select Season...</option>
        {this.seasonOptions()}
      </FormControl>
    )
  }

  setSearchDateField = () => {
    return (
      <InputGroup>
        <ControlLabel style={{ minWidth: '71px', marginRight: '4px' }}>Start Date</ControlLabel>
        <FormControl type='date' id='startDate' style={{ minWidth: '150px' }} className='unstyled' onChange={this.handleStartDateChange} />
        <ControlLabel style={{ minWidth: '71px', marginRight: '4px' }}>End Date</ControlLabel>
        <FormControl type='date' id='endDate' style={{ minWidth: '150px' }} className='unstyled' onChange={this.handleEndDateChange} />
      </InputGroup>
    )
  }

  render() {
    const { oilRatiosList, seasonSettingsList, pointsByEventList, rankingExceptionsList, lowGameCountList, seasonsBowledList, eventByEventList, standingsByEventList, reportType, makingReportRequest } = this.state
    let data = []
    let headers = []
    let filename = ''

    if (reportType === searchTypes.OilRatios) {
      data = oilRatiosList
      headers = OilRatioHeaders
      filename = 'OilRatios.csv'
    }
    else if (reportType === searchTypes.SeasonSettings) {
      data = seasonSettingsList
      headers = SeasonSettingsHeaders
      filename = 'SeasonSettings.csv'
    }
    else if (reportType === searchTypes.PointsByEvent) {
      data = pointsByEventList
      headers = PointsByEventHeaders
      filename = 'PointsByEvent.csv'
    }
    else if (reportType === searchTypes.RankingExceptions) {
      data = rankingExceptionsList
      headers = RankingExceptionsHeaders
      filename = 'RankingException.csv'
    }
    else if (reportType == searchTypes.LowGameCount) {
      data = lowGameCountList
      headers = LowGameCountHeaders
      filename = 'LowGameCount.csv'
    }
    else if (reportType === searchTypes.SeasonsBowled) {
      data = seasonsBowledList
      headers = SeasonsBowledHeaders
      filename = 'SeasonsBowled.csv'
    }
    else if (reportType === searchTypes.EventByEvent) {
      data = eventByEventList
      headers = EventByEventHeaders
      filename = 'YearEndSinglesAvg.csv'
    }
    else if (reportType === searchTypes.StandingsByEvent) {
      data = standingsByEventList
      headers = StandingsByEventHeaders
      filename = 'YearEndEventStandings.csv'
    }

    const disableReport = this.disableSearchButton()
    const reportIcon = makingReportRequest ? 'fa fa-spinner fa-spin ' : 'fa fa-file-excel-o'
    return (
      <ContentWrapper>
        <div className="content-heading">Season Reports</div>
        <form id="seasonreports" className="form-horizontal">
          <Row>
            <Col xs={12}>
              <div className="stacked-filter-panel" style={{ width: '100%' }}>
                <FormGroup xs={12}>
                  <InputGroup>
                    <ControlLabel style={{ minWidth: '71px', marginRight: '4px' }}>Report Type</ControlLabel>
                    <FormControl defaultValue={searchTypes.OilRatios} componentClass="select"
                      placeholder="All" onChange={this.handleSearchTypeChange}
                      style={{ minWidth: '180px', borderRadious: '0' }}>
                      <option value={searchTypes.OilRatios}>Oil ratio by event</option>
                      <option value={searchTypes.SeasonSettings}>Season settings by season</option>
                      <option value={searchTypes.PointsByEvent}>Points by event</option>
                      <option value={searchTypes.RankingExceptions}>Ranking exceptions</option>
                      <option value={searchTypes.LowGameCount}>Low games count</option>
                      <option value={searchTypes.SeasonsBowled}>Seasons Bowled</option>
                      <option value={searchTypes.EventByEvent}>Year End Singles</option>
                      <option value={searchTypes.StandingsByEvent}>Year End Event Standings</option>
                    </FormControl>
                    {reportType === searchTypes.OilRatios && this.setSearchDateField()}
                    {reportType === searchTypes.SeasonSettings && this.setSelectValues()}
                    {reportType === searchTypes.PointsByEvent && this.setSelectValues()}
                    {reportType === searchTypes.RankingExceptions && this.setSearchDateField()}
                    {reportType == searchTypes.LowGameCount && this.setSearchDateField()}
                    {reportType == searchTypes.SeasonsBowled && this.setSelectValues()}
                    {reportType == searchTypes.EventByEvent && this.setSelectValues()}
                    {reportType == searchTypes.StandingsByEvent && this.setSelectValues()}
                    <Button style={reportStyle} disabled={disableReport} onClick={this.handleGenerateReport}>
                      <i className={reportIcon} aria-hidden="true" />&nbsp;&nbsp;Generate Report (.csv)
                    </Button>
                    <CSVLink
                      id="csvLink"
                      data={data}
                      headers={headers}
                      filename={filename}
                      target='_blank'
                      className='hidden'
                      style={reportStyle}
                    />
                  </InputGroup>
                </FormGroup>
              </div>
            </Col>
          </Row>
        </form>
      </ContentWrapper>)
  }
}

export default Reports



// WEBPACK FOOTER //
// ./src/components/pages/Report/index.js